import styled from "styled-components/native"

export const SwitchContainer = styled.View`
  flex: 0.2;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`
